import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIndirectRateStructure from './indirect-rate-structure.reducer';

export const selectIndirectRateStructureState =
    createFeatureSelector<fromIndirectRateStructure.State>(
        fromIndirectRateStructure.indirectRateStructuresFeatureKey
    );

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromIndirectRateStructure.adapter.getSelectors(
        selectIndirectRateStructureState
    );

export const selectIndirectRateTypes = createSelector(
    selectIndirectRateStructureState,
    x => x.IndirectRateTypes
);
